import React, { useEffect, useMemo, useState } from 'react';
import RangePicker from '@/pages/home/components/RangePicker';
import { moment2String, string2Moment } from '@/pages/datalab/components/SortableDrag/utils';
import './TimeRangePicker.scss';
export interface TimeRangePickerProps {
  value: any;
  onConfirmBack: (value: any) => void;
  language: string;
}

const tabName = ['date', 'week', 'month'];
export function TimeRangePicker(props: TimeRangePickerProps) {
  const { value, onConfirmBack, language } = props;
  const [type, setType] = useState(tabName[0]);
  const [date, setDate] = useState<any[]>([]);

  const tempValue = useMemo(() => [string2Moment(value[0]), string2Moment(value[1])], [JSON.stringify(value)]);

  useEffect(() => {
    let newDate = [...date];
    if (!(newDate?.[0] && newDate?.[1])) {
      newDate = [...tempValue];
    }
    if (type === 'month') {
      newDate[0] = newDate[0].startOf('month');
      newDate[1] = newDate[1].endOf('month');
    }
    onConfirmBack([moment2String(newDate[0]), moment2String(newDate[1])]);
  }, [date, type]);

  return (
    <div className="dtl-time-range-picker">
      <RangePicker
        key="range-picker"
        type={type}
        typeList={tabName}
        startOfWeek={0}
        language={language}
        showSelectType={true}
        value={tempValue}
        defaultValue={tempValue}
        onChange={(value, type) => {
          setType(type);
          if (value?.[0] && value?.[1]) {
            setDate([...value]);
          }
        }}
      />
    </div>
  );
}
